import { j as l } from "./jsx-runtime-e6RZPHeG.js";
import { memo as i } from "react";
const r = ({
  title: e,
  titleId: c,
  ...o
}) => /* @__PURE__ */ l.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 1024 1024",
    role: "img",
    "aria-labelledby": c,
    ...o,
    children: [
      e ? /* @__PURE__ */ l.jsx("title", { id: c, children: e }) : null,
      /* @__PURE__ */ l.jsx(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M509.477 927.721h-16.362c-123.517 0-215.782-128.065-215.782-242.578l.384-369.53c0-91.684 72.916-166.28 162.535-166.28h5.035c89.619 0 162.535 74.596 162.535 166.28v14.142c.32 2.095.491 4.256.491 6.438v352.725c0 61.021-47.978 110.671-106.984 110.671-59.028 0-107.027-49.65-107.027-110.671V338.812c0-24.116 19.093-43.649 42.666-43.649 23.551 0 42.666 19.533 42.666 43.649v350.106c0 12.68 9.898 23.374 21.631 23.374 11.797 0 21.717-10.694 21.717-23.374V342.587a42.726 42.726 0 0 1-.491-6.438v-20.537c0-43.54-34.623-78.982-77.203-78.982h-5.035c-42.58 0-77.203 35.443-77.203 78.982l-.384 369.596c0 70.253 58.196 155.215 130.45 155.215h16.362c72.276 0 130.45-84.962 130.45-155.28V318.821c0-24.116 19.114-43.649 42.666-43.649 23.573 0 42.666 19.533 42.666 43.649v366.322c0 114.512-92.264 242.578-215.782 242.578z",
          clipRule: "evenodd"
        }
      )
    ]
  }
), m = i(r);
export {
  m as default
};
